/**
 * Newswire banner.
 *
 * @author Simon Lagerlöf <contact@smn.codes>
 * @copyright 2024 Simon Lagerlöf
 * @since 1.0.0
 */
import { getCookie, setCookie } from 'typescript-cookie';
import type AlpineComponent from '../types/alpine-component';

type NewswireBanner = AlpineComponent<{}>;

class NewsWireBannerState {
  private cookieName = 'rd_newswire_banner_hidden';

  public get isVisible(): boolean {
    return getCookie(this.cookieName) !== 'true';
  }

  public hide(): void {
    setCookie(this.cookieName, true, {
      expires: 14,
      sameSite: 'strict',
      secure: true,
      path: '/',
    });
  }
}

const bannerState = new NewsWireBannerState();

const className = 'newswire-banner--hidden';

export const newswireBanner = (): NewswireBanner => ({
  init() {
    if (bannerState.isVisible) {
      this.$refs.newswireBanner.classList.remove(className);
    }
  },

  hide() {
    bannerState.hide();
    this.$refs.newswireBanner.classList.add(className);
  },
});
